var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNoSubscriptionsPlaceholder(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 216,
    height: 216,
    viewBox: "0 0 216 216",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 108,
    cy: 108,
    r: 108,
    fill: "#F3F6FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66 73C66 72.4477 66.4477 72 67 72H149C149.552 72 150 72.4477 150 73V143C150 143.552 149.552 144 149 144H67C66.4477 144 66 143.552 66 143V73Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M67 67H149C152.314 67 155 69.6863 155 73V143C155 146.314 152.314 149 149 149H67C63.6863 149 61 146.314 61 143V73C61 69.6863 63.6863 67 67 67ZM67 72C66.4477 72 66 72.4477 66 73V143C66 143.552 66.4477 144 67 144H149C149.552 144 150 143.552 150 143V73C150 72.4477 149.552 72 149 72H67Z",
    fill: "#1F2D5C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66 89.9995H150V72.9995C150 72.4472 149.552 71.9995 149 71.9995H67C66.4477 71.9995 66 72.4472 66 72.9995V89.9995Z",
    fill: "#1F2D5C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M87.5 72C86.1193 72 85 70.8807 85 69.5L85 56.5C85 55.1193 86.1193 54 87.5 54C88.8807 54 90 55.1193 90 56.5L90 69.5C90 70.8807 88.8807 72 87.5 72Z",
    fill: "#1F2D5C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M135.5 72C134.119 72 133 70.8807 133 69.5L133 56.5C133 55.1193 134.119 54 135.5 54C136.881 54 138 55.1193 138 56.5L138 69.5C138 70.8807 136.881 72 135.5 72Z",
    fill: "#1F2D5C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96 115.727L104 123L120 107",
    stroke: "#1F2D5C",
    strokeWidth: 5,
    strokeLinecap: "round"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoSubscriptionsPlaceholder);
export default __webpack_public_path__ + "static/media/no-subscriptions-placeholder.88795406.svg";
export { ForwardRef as ReactComponent };